import { render } from "./QMSatData.vue?vue&type=template&id=23a2bbf0&scoped=true"
import script from "./QMSatData.vue?vue&type=script&lang=js"
export * from "./QMSatData.vue?vue&type=script&lang=js"

import "./QMSatData.vue?vue&type=style&index=0&id=23a2bbf0&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a2bbf0"]])

export default __exports__